export function formatPrice(
  amount: number | string,
  currency: string,
  locale: string,
  options?: Omit<Intl.NumberFormatOptions, 'style' | 'currency'>,
): string {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    // Hide zero decimals without ever rounding a real fraction away.
    trailingZeroDisplay: 'stripIfInteger',
    ...options,
  });

  return formatter.format(Number(amount));
}